import React from "react";
import { MdCircle } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { RxExternalLink } from "react-icons/rx";
import { Link } from "react-router-dom";
import HoverToDisplayFullTitle from "../../reusableComponents/HoverToDisplayFullTitle";
import { Tooltip } from "@mui/material";
import { useAuth } from "../../context/API_Client";
import { upiIntentLogoDictionary } from "../utils/utils";
import { colorBrandObject } from "../../../constants/brandings";

const TransactionRenderer = ({ data }) => {
  const transacId = data.transactionId;
  const { isAuthorizedPermission } = useAuth();

  const canViewTransaction = isAuthorizedPermission("VIEW_ORDER_DETAILS");

  return (
    <div
      style={{
        display: "flex",
        marginLeft: "-12px",
        alignItems: "center",
        minWidth: "100px",
        paddingRight: "30px",
      }}
    >
      <div
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          flex: 1,
        }}
      >
        {transacId}
        {canViewTransaction ? (
          <Link
            id="transaction-refund-link"
            to={
              "/transacs/payment_details/transaction_Details?transactionId=" + transacId
            }
            target="_blank"
          >
            <RxExternalLink
              style={{
                width: "24px",
                height: "16px",
                cursor: "pointer",
                position: "absolute",
                right: "0",
                marginRight: "16px",
                color: `${colorBrandObject?.actionIconColor}`
              }}
            />
          </Link>
        ) : (
          <Tooltip title={"Access denied contact Admin"} arrow>
            <span
              style={{
                color: "gray",
              }}
            >
              {transacId && (
                <RxExternalLink
                  style={{
                    width: "24px",
                    height: "16px",
                    cursor: "pointer",
                    position: "absolute",
                    right: "0",
                    marginRight: "16px",
                    color: `${colorBrandObject?.actionIconColor}`
                  }}
                ></RxExternalLink>
              )}
            </span>
          </Tooltip>
        )}
      </div>
    </div>
  );
};
export const refundSchema = {
  metadata: {
    title: "Refunds",
    minHeight: 600,
    position: "relative",
    rowHeight: 60,
    showTitle: false,
    defaultSortInfo: { name: "timestamp", dir: -1 },
    defaultVisible: [
      "transactionId",
      "operationName",
      "authAmount",
      "amount",
      "pspCode",
      "operationStatus",
    ],
  },
  fields: [
    {
      name: "transactionId",
      header: "Transaction ID",
      visible: true,
      type: "string",
      filtering: false,
      minWidth: 180,
      defaultFlex: 1,
      textAlign: "center",
      sortable: false,
      render: TransactionRenderer,
    },
    {
      name: "operationName",
      header: "Operations",
      visible: true,
      type: "string",
      filtering: false,
      minWidth: 190,
      defaultFlex: 1,
      textAlign: "start",
      sortable: false,
      render: ({ value }) => (
        <span
          style={{ display: "flex", marginLeft: "-12px", alignItems: "center" }}
        >
          <MdCircle
            style={{
              width: "8px",
              height: "8px",
              color:
                value === ("Authorisation" && "Capture")
                  ? "#188D63"
                  : "rgba(158, 87, 7, 1)",
            }}
          />
          &nbsp; &nbsp;
          {value}
        </span>
      ),
    },
    {
      name: "paymentMethodType",
      header: "Method",
      visible: false,
      type: "string",
      filtering: false,
      minWidth: 120,
      defaultFlex: 1,
      textAlign: "start",
      sortable: false,
      render: ({ data }) => (
        <span
          style={{ display: "flex", marginLeft: "-15px", alignItems: "center" }}
        >
          {data?.paymentMethodTypeLocale && (
            <img
              src={
                data?.paymentMethodTypeLocale === "EMI"
                  ? "/assets/Icons/Payment Instruments/EMI.svg"
                  : upiIntentLogoDictionary(data?.paymentMethodSubBrand) ||
                  data?.paymentMethodLogoUrl
              }
              style={{
                height: "28px",
                width: "28px",
                objectFit: "contain",
                marginRight: "8px",
                mixBlendMode: "multiply",
              }}
            />
          )}
          {data.paymentMethodTypeLocale === "Buy Now Pay Later"
            ? "BNPL"
            : data.paymentMethodTypeLocale}
        </span>
      ),
    },
    {
      name: "authAmount",
      header: "Order Amount",
      visible: true,
      type: "string",
      filtering: false,
      minWidth: 180,
      defaultFlex: 1,
      textAlign: "start",
      sortable: false,
      render: ({ data }) => (
        <span style={{ display: "flex", marginLeft: "-8px" }}>
          {data.authAmount !== undefined ? data.authAmountLocale : ""}
        </span>
      ),
    },
    {
      name: "amount",
      header: "Refunded Amount",
      visible: true,
      type: "string",
      filtering: false,
      minWidth: 200,
      defaultFlex: 1,
      textAlign: "start",
      sortable: false,
      render: ({ data }) => (
        <span style={{ display: "flex", marginLeft: "-8px" }}>
          {`${data?.currencyCode} ${data?.amountLocaleFull}`}
        </span>
      ),
    },
    {
      name: "pspCode",
      header: "Processor",
      visible: true,
      type: "string",
      filtering: false,
      minWidth: 140,
      defaultFlex: 1,
      textAlign: "start",
      sortable: false,
      render: ({ data }) => (
        <span
          style={{ display: "flex", marginLeft: "-20px", alignItems: "center" }}
        >
          <img
            src={data.pspCodeLogoURL}
            style={{
              height: "28px",
              width: "28px",
              objectFit: "contain",
              marginRight: "8px",
              mixBlendMode: "multiply",
            }}
          />

          {data.pspCodeLocale}
        </span>
      ),
    },
    {
      name: "clientPosId",
      header: "Store ID",
      visible: false,
      type: "string",
      filtering: false,
      //defaultWidth: 222,
      textAlign: "start",
      sortable: false,
      minWidth: 200,
      render: ({ data }) => (
        <span style={{ marginLeft: "-12px" }}>{data?.clientPosId}</span>
      ),
    },
    {
      name: "countryCode",
      header: "Country",
      visible: false,
      type: "string",
      filtering: false,
      textAlign: "start",
      sortable: false,
    },
    {
      name: "currencyCode",
      header: "Currency",
      visible: false,
      type: "string",
      filtering: false,
      textAlign: "start",
      sortable: false,
    },
    {
      name: "latestOperationName",
      header: "Latest Operation Name",
      visible: false,
      type: "string",
      filtering: false,
      textAlign: "start",
      sortable: false,
      minWidth: 240,
    },
    {
      name: "legalEntity",
      header: "Legal Entity",
      visible: false,
      type: "string",
      filtering: false,
      textAlign: "start",
      sortable: false,
    },
    {
      name: "merchantId",
      header: "Merchant ID",
      visible: false,
      type: "string",
      filtering: false,
      textAlign: "start",
      sortable: false,
    },
    {
      name: "noOfPspRetries",
      header: "No. of PSP Retries",
      visible: false,
      type: "string",
      filtering: false,
      textAlign: "start",
      sortable: false,
      minWidth: 200,
    },
    {
      name: "operationId",
      header: "Operation ID",
      visible: false,
      type: "string",
      filtering: false,
      textAlign: "start",
      sortable: false,
      minWidth: 180,
    },
    // {
    //   name: "operationStatus",
    //   header: "Operation Status",
    //   visible: false,
    //   type: "string",
    //   filtering: false,
    //   textAlign: "start",
    //   sortable: false,
    //   minWidth: 200,
    // },
    {
      name: "order",
      header: "Order",
      visible: false,
      type: "string",
      filtering: false,
      textAlign: "start",
      sortable: false,
    },
    {
      name: "orderId",
      header: "Order ID",
      visible: false,
      type: "string",
      filtering: false,
      textAlign: "start",
      sortable: false,
    },
    // {
    //   name: "paymentMethodType",
    //   header: "Payment Category",
    //   visible: false,
    //   type: "string",
    //   filtering: false,
    //   textAlign: "start",
    //   sortable: false,
    // },
    {
      name: "statusReason",
      header: "Reason Code",
      visible: false,
      type: "string",
      filtering: false,
      textAlign: "start",
      sortable: false,
      minWidth: 180,
      render: ({ data }) => {
        return (
          <span
            style={{
              marginLeft: "-12px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {data?.statusReason && (
              <HoverToDisplayFullTitle title={data?.statusReason} len={25} />
            )}
          </span>
        );
      },
    },
    {
      name: "timesStamp",
      header: "Date",
      visible: false,
      type: "string",
      filtering: false,
      textAlign: "start",
      sortable: false,
      render: ({ data }) => (
        <span style={{ marginLeft: "-12px" }}>
          {data.timestamp.split(" ")[0]}
        </span>
      ),
    },
    {
      name: "operationStatus",
      header: "Refund Status",
      visible: true,
      type: "string",
      filtering: false,
      minWidth: 180,
      defaultFlex: 1,
      textAlign: "start",
      sortable: false,
      render: ({ value }) => {
        let backgroundColor;
        let color;

        if (value === "Failed" || value === "Rejected" || value?.toLowerCase() === "declined") {
          backgroundColor = "#FDE3D6";
          color = "#B9232F";
        } else if (
          value === "Pending" ||
          value === "Initiated" ||
          value === "Redirection" ||
          value?.toLowerCase() === "reviewed" ||
          value === "Pending Review"

        ) {
          backgroundColor = "#FBEFCB";
          color = "#9E5707";
        } else if (
          value === "Approved" ||
          value === "Settled" ||
          value === "Received" ||
          value === "Refund Review Approved" ||
          value === "Partially Refunded"
        ) {
          backgroundColor = "#D5FBD2";
          color = "#0B6A48";
        }
        return (
          <span
            style={{
              marginLeft: "-20px",
              paddingBottom: "6px",
              paddingRight: "8px",
              paddingLeft: "8px",
              paddingTop: "5px",
              borderRadius: "8px",
              backgroundColor,
              color,
              textTransform: "uppercase"
            }}
          >
            {value}
          </span>
        );
      },
    },
  ],
};
